import { readonly, shallowRef } from "vue";
import isModifierSet from "./userModifier";
import { ModifierType } from "./userModifierEnum";

export interface HalloweenArchiveTarget {
  key: string;
  left: number;
  top: number;
  width: number;
  height: number;
}

const archiveTarget = shallowRef<HalloweenArchiveTarget>();
export const halloweenArchiveTarget = readonly(archiveTarget);
const webbedEvents = shallowRef<ReadonlyMap<string, string>>(new Map());
export const halloweenWebbedEvents = readonly(webbedEvents);

export function triggerHalloweenArchiveSpider(event: {
  id: number;
  __typename?: string;
  deletedAt?: string;
}) {
  if (
    !isModifierSet(ModifierType.halloweenSpider) ||
    event.__typename !== "SQDCEvent" ||
    event.deletedAt == null
  ) {
    return;
  }
  const key = `${event.__typename}:${event.id}`;
  const element = Array.from(document.querySelectorAll<HTMLElement>("[data-halloween-event]")).find(
    (row) => {
      if (row.dataset.halloweenEvent !== key) return false;
      const rect = row.getBoundingClientRect();
      return (
        rect.height > 0 &&
        rect.width > 0 &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight &&
        rect.right > 0 &&
        rect.left < window.innerWidth
      );
    },
  );
  if (!element) return;
  const rect = element.getBoundingClientRect();

  webbedEvents.value = new Map([...webbedEvents.value, [key, event.deletedAt]]);
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  archiveTarget.value = {
    key,
    left: Math.max(0, rect.left),
    top: Math.max(0, rect.top),
    width: Math.min(window.innerWidth, rect.right) - Math.max(0, rect.left),
    height: Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top),
  };
}
